import {
  ExamDistributionList,
  ExamDistributionListFilterSection,
} from '@exam-center/exam-distribution-list';
import { Flex, Paper } from '@shared/components';

export default function ExamDistributionByYearPage() {
  return (
    <Flex sx={{ p: (theme) => theme.spacing(6), flexGrow: 1, width: '100%' }}>
      <Paper
        sx={(theme) => ({
          borderRadius: theme.shape.rounded(2),
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(6),
          height: '100%',
          padding: theme.spacing(6),
          width: '100%',
        })}
      >
        <ExamDistributionListFilterSection />
        <ExamDistributionList />
      </Paper>
    </Flex>
  );
}
